"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfiniteScroll = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _tools = require("../../utils/tools");
var _useForwardRef3 = _interopRequireDefault(require("../../hooks/useForwardRef"));
var _Loader = require("../Loader");
var _excluded = ["className", "disabled", "distance", "children", "onLoadMore", "showLoading"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var InfiniteScroll = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var className = props.className,
    disabled = props.disabled,
    _props$distance = props.distance,
    distance = _props$distance === void 0 ? 100 : _props$distance,
    children = props.children,
    onLoadMore = props.onLoadMore,
    _props$showLoading = props.showLoading,
    showLoading = _props$showLoading === void 0 ? false : _props$showLoading,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useForwardRef = (0, _useForwardRef3.default)(ref),
    _useForwardRef2 = (0, _slicedToArray2.default)(_useForwardRef, 2),
    wrapperRef = _useForwardRef2[0],
    setWrapperRef = _useForwardRef2[1]; // 节流频率

  var THROTTLE_INTERVAL = 200;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var handleScroll = (0, _tools.throttle)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var el, nearBottom;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!loading) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            el = wrapperRef.current;
            if (el) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return");
          case 5:
            nearBottom = (el === null || el === void 0 ? void 0 : el.scrollHeight) - (el === null || el === void 0 ? void 0 : el.scrollTop) - (el === null || el === void 0 ? void 0 : el.clientHeight) <= distance;
            if (!nearBottom) {
              _context.next = 11;
              break;
            }
            setLoading(true);
            _context.next = 10;
            return onLoadMore();
          case 10:
            setLoading(false);
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), THROTTLE_INTERVAL);
  var Loading = /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat((0, _getPrefixCls.getPrefixCls)('infinite-scroll'), "--loading")
  }, /*#__PURE__*/_react.default.createElement(_Loader.ListLoader, null));
  return /*#__PURE__*/(
    // @ts-ignore
    _react.default.createElement("div", (0, _extends2.default)({
      className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('infinite-scroll'), className),
      role: "feed",
      onScroll: !disabled ? handleScroll : undefined,
      ref: setWrapperRef
    }, other), children, showLoading && loading && Loading)
  );
});
exports.InfiniteScroll = InfiniteScroll;